import { Head, Link } from "@inertiajs/react"
import { ArrowLeft } from "lucide-react"

import { Button } from "@/components/ui/button"
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card"
import AuthLayout from "@/layouts/auth-layout"
import { newPartnerUserPasswordPath, newPartnerUserSessionPath } from "@/routes"

interface ErrorProps {
  message: string
}

export default function PasswordResetError({ message }: ErrorProps) {
  return (
    <AuthLayout title="" description="">
      <Head title="Password reset failed" />
      <div className="flex w-full flex-col gap-6">
        <Card>
          <CardHeader className="text-center">
            <CardTitle className="text-xl">Password reset failed</CardTitle>
            <CardDescription>{message}</CardDescription>
          </CardHeader>
          <CardContent className="flex flex-col items-center gap-3">
            <Button asChild className="w-full">
              <Link href={newPartnerUserPasswordPath()}>
                Request new reset link
              </Link>
            </Button>
            <Button variant="ghost" asChild className="flex items-center gap-2">
              <Link href={newPartnerUserSessionPath()}>
                <ArrowLeft className="h-4 w-4" />
                Back to login
              </Link>
            </Button>
          </CardContent>
        </Card>
      </div>
    </AuthLayout>
  )
}
